import { takeLatest, call, put } from 'redux-saga/effects';
import { memberActionTypes } from './Member.actionTypes';
import memberSessionService from '../../services/memberSessions';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';

const emptyTimeData = {
  totalHours: 0,
  totalMinutes: 0,
  idleHours: 0,
  idleMinutes: 0,
  productiveHours: 0,
  productiveMinutes: 0,
};

export function* getSessionTimeLogDaySaga({ payload }) {
  try {
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        memberLoading: true,
        timelogDayRange: payload?.day,
      },
    });

    const response = yield call(memberSessionService.getSessionsForDay, {
      companyId: payload?.companyId,
      employeeId: payload?.employeeId,
      dayOffset: payload?.day ?? 0,
      timeZone: payload?.timeZone,
    });

    const totals = response?.data?.totals || {};
    const timeData = response?.success
      ? {
          totalHours: totals.totalHours ?? 0,
          totalMinutes: totals.totalMinutes ?? 0,
          idleHours: totals.idleHours ?? 0,
          idleMinutes: totals.idleMinutes ?? 0,
          productiveHours: totals.productiveHours ?? 0,
          productiveMinutes: totals.productiveMinutes ?? 0,
        }
      : emptyTimeData;

    const sessionTimeData = response?.success
      ? {
          startTime: totals.startTime || null,
          endTime: totals.endTime || null,
          timeZone: totals.timeZone,
          day: payload?.day ?? 0,
        }
      : {};

    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        memberLoading: false,
        memberTimeData: timeData,
        sessionTimeData,
      },
    });
  } catch (error) {
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        memberLoading: false,
        memberTimeData: emptyTimeData,
      },
    });
    addNotification({
      message: error?.message || 'Failed to fetch session data',
      level: notificationStates.error,
    });
  }
}

export default function* memberSessionWatcher() {
  yield takeLatest(
    memberActionTypes.GET_SESSION_TIMELOG_DAY,
    getSessionTimeLogDaySaga
  );
}
